import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as InstagramIcon } from '../../assets/svg/InstagramIcon.svg';
import { helpFooter, legalFooter, resourcesFooter } from '../../constatnts/FooterConstants';

function Footer() {
    return (
        <>
            <div className="hidden sm:block w-full  bg-basicBackground text-white pt-[60px] lg:pt-[75px] px-5 lg:px-[100px] pb-8">
                <div className=" grid grid-cols-4 gap-6">
                    <div className="flex flex-col gap-6 pr-12">
                        <Link to={'/'}>
                            <p className="text-[28px] leading-8 text-white font-bold">Puškica kviz</p>
                        </Link>
                        <p className="text-[14px] leading-5 text-white font-normal">
                            Platforma za učenje i zabavu - otkrijte svet znanja kroz interaktivne kvizove i izazove!
                        </p>
                        {/* <a
                            href="https://www.instagram.com/punorman.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center rounded-full bg-white h-10 w-10"
                        >
                            <InstagramIcon />
                        </a> */}
                    </div>
                    <FooterLink item={resourcesFooter} />
                    <FooterLink item={helpFooter} />
                    <FooterLink item={legalFooter} />
                </div>
                <div className="w-full min-h-[1px] bg-blueSuperLight mt-16"></div>

                <a href="mailto:puskica.kviz@gmail.com" className="text-[16px] leading-5 text-white font-normal ">
                    puskica.kviz@gmail.com
                </a>
            </div>
            <div className="block sm:hidden w-full  bg-basicBackground text-white pt-[60px]  px-5  pb-10">
                <div className="w-full flex flex-col gap-[50px]">
                    <div className="flex flex-col gap-6 pr-12">
                        <Link to={'/'}>
                            <p className="text-[28px] leading-8 text-white font-bold">Puškica kviz</p>
                        </Link>
                        <p className="text-[14px] leading-5 text-white font-normal">
                            Platforma za učenje i zabavu - otkrijte svet znanja kroz interaktivne kvizove i izazove!
                        </p>
                        {/* <a
                            href="https://www.instagram.com/punorman.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center rounded-full bg-white h-10 w-10"
                        >
                            <InstagramIcon />
                        </a> */}
                    </div>
                    <FooterLink item={resourcesFooter} />
                    <FooterLink item={helpFooter} />
                    <FooterLink item={legalFooter} />
                </div>
                <div className="w-full h-[1px] bg-iron mt-[72px]"></div>
                <a href="mailto:puskica.kviz@gmail.com" className="text-[16px] leading-5 text-white font-normal mt-[26px]">
                    puskica.kviz@gmail.com
                </a>
            </div>
        </>
    );
}

export default Footer;
const FooterLink = ({ item }: { item: any }) => {
    return (
        <div className="flex flex-col gap-[32px] ">
            <p className="text-[20px] leading-6 text-white font-medium">{item?.title}</p>
            <div className="flex flex-col gap-4">
                {item?.links?.map((link: any, index: number) => {
                    return (
                        <Link to={link?.link} key={index}>
                            <p className="text-[16px] leading-5 text-white font-normal">{link.title}</p>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};
